import { HTMLMotionProps, motion } from 'framer-motion'
import * as React from 'react'

const AnimatedButton: React.FC<HTMLMotionProps<'button'>> = (props) => {
  return <motion.button {...props} whileTap={{ scale: 0.92 }} />
}

export default AnimatedButton
